import { useEffect, useState } from 'react';
import { useBusinessStore } from '../store/useBusinessStore';
import { supabase } from '../supabaseClient';
import { isLidOnly, phoneKey } from '../utils/customers';

// Conversación de WhatsApp de una ficha. n8n guarda cada mensaje (entrante o saliente) en customer_messages;
// se cruza por los últimos 10 dígitos del teléfono y/o por el identificador interno (lid) de la persona.
export const useCustomerMessages = (customer, limit = 200) => {
  const { activeBusinessId } = useBusinessStore();
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [tableMissing, setTableMissing] = useState(false);

  const phone = customer?.phone;
  const lid = customer?.lid || (isLidOnly(customer) ? phone : null);
  const key = isLidOnly(customer) ? '' : phoneKey(phone);

  useEffect(() => {
    if (!activeBusinessId || (!key && !lid)) { setLoading(false); return undefined; }
    let cancelled = false;
    const filters = [key && `phone_key.eq.${key}`, lid && `lid.eq.${lid}`].filter(Boolean).join(',');
    (async () => {
      setLoading(true);
      const { data, error } = await supabase
        .from('customer_messages')
        .select('id, direction, body, msg_type, sent_at')
        .eq('business_id', String(activeBusinessId))
        .or(filters)
        .order('sent_at', { ascending: false })
        .limit(limit);
      if (cancelled) return;
      if (error) {
        setTableMissing(['42P01', 'PGRST205'].includes(error.code) || /customer_messages/i.test(error.message || ''));
        setMessages([]);
      } else {
        setTableMissing(false);
        setMessages(Array.isArray(data) ? [...data].reverse() : []);
      }
      setLoading(false);
    })();
    return () => { cancelled = true; };
  }, [activeBusinessId, key, lid, limit]);

  return { messages, loading, tableMissing };
};
